import '@fontsource/roboto/300';
import '@fontsource/roboto/400';
import '@fontsource/roboto/500';
import '@fontsource/roboto/700';
//  Externals
import reportWebVitals from 'reportWebVitals';
import ReactDOM from 'react-dom';
import React from 'react';
// Internals
import App from './App';
// Use consistent styling
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'sanitize.css/sanitize.css';
import './app/style.sass';
//  Microsoft Authentication Library for React
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './configs/msalInstance';

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>,
  MOUNT_NODE,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
